//Quick and Dirty
declare var require: any

import { Component, OnInit, ViewChild } from '@angular/core';
import { RebateRequestComponent } from 'src/app/front-user/services/long-haul/rebate-request/rebate-request.component';
import { LongHaulService } from 'src/app/shared/services/long-haul.service';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { LongHaulRequestOption, LongHaulRequestFormulateDecision, LongHaulRequestOptionFormulatedDecision } from 'src/app/shared/models/long-haul.model';
import { User } from 'src/app/front-user/shared/models/user.model';
import { Router } from '@angular/router';
import { ErrorsEnum } from 'src/app/shared/models/enums.model';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';

@Component({
  selector: 'app-rebate-request-formulatd-decision',
  templateUrl: './rebate-request-formulatd-decision.component.html'
})

export class RebateRequestFormulatdDecisionComponent implements OnInit {
  //#region Properties & Variables
  public isRequestSucceeded: boolean = false;
  public isRestudySucceeded: boolean = false;
  @ViewChild('rebateRequest',{static: false}) rebateRequest: RebateRequestComponent;
  private rebateRequestId: string = "";
  private longHaulRequestFormulateDecisionRequest: LongHaulRequestFormulateDecision = new LongHaulRequestFormulateDecision();
  private longHaulRequestFormulateDecisionResponse: LongHaulRequestFormulateDecision = new LongHaulRequestFormulateDecision();
  private getRequestToFormulateDecisionResponseObject: ResponseObject = new ResponseObject();
  private currentTodayDateObj: Date = new Date();
  //Read Only Properties
  private currentTodayDate: string = "";
  //Options Properties
  public currentSelctedOption: string = null;
  public longHaulRequestOptions: LongHaulRequestOption[] = [];
  private isOptionDetailsSelected: boolean = false;
  private optionSelectedText: string = "";
  private selectedLongHaulRequestOption: LongHaulRequestOptionFormulatedDecision = new LongHaulRequestOptionFormulatedDecision();
  private isFormSubmitted: boolean = false;
  //User Properties
  public currentUser: User = new User();
  //Submit
  private formulateDecisionResponseObject: ResponseObject = new ResponseObject();
  private RestudyResponseObject: ResponseObject = new ResponseObject();
  //Loading Components
  private noOfLoadedLookups: number = 0;
  private noOfLoadingLookups: number = 1;
  //Request History
  private isRequestHistoryComponent: boolean = false;
  private submittedFormulatedDecision: string;
  private getFormulatedDecisionResponseObject: ResponseObject = new ResponseObject();
  public submitConfirmationMode: ConfirmationMode = ConfirmationMode.Success;
  //#endregion

  constructor(private longHaulService: LongHaulService, private globalServices: GlobalServices, private router: Router, private authenticationService: AuthenticationService) {
    //this.currentUser = this.globalServices.user;
    this.currentUser = this.authenticationService.currentUserValue;
    if(history.state.data && history.state.data.isCompleted)
      this.isRequestHistoryComponent = true;
    //else
    //  this.longHaulRequestFormulateDecisionResponse.FormulatedDecision = "This Offer is final, waiting for your reply and ETA within 72 Hours";
  }

  ngOnInit() { }
  onRebateRequestLoadedFlag(flag: boolean) {
    //Enable Loader
    this.globalServices.isLoaderEnabled = true;
    if(flag){
      this.rebateRequestId = this.rebateRequest.rebateRequestLoaded.Id;
      this.rebateRequest.showOptionDev = false;
      this.rebateRequest.editModeAdmin = true;
      this.longHaulRequestOptions = this.rebateRequest.rebateRequestLoaded.LongHaulRequestOptions;
      this.getRebateRequestOptions();
      if(this.isRequestHistoryComponent){
        this.noOfLoadingLookups = 2;
        this.getFormulatedDecision();
      }
    }
  }
  onOptionChange(): void {
    let selectedOptions = event.target['options'];
    let selectedIndex = selectedOptions.selectedIndex;
    this.optionSelectedText = selectedOptions[selectedIndex].text;
    if(this.currentSelctedOption != "null") {

      this.selectedLongHaulRequestOption = this.longHaulRequestFormulateDecisionResponse.LongHaulRequestOptionsFormulatedDecision.filter(o => o.Id == this.currentSelctedOption)[0];
      this.isOptionDetailsSelected = true;
    } else {
      this.selectedLongHaulRequestOption = new LongHaulRequestOptionFormulatedDecision();
      this.isOptionDetailsSelected = false;
    }
  }
  getRebateRequestOptions(): void {
    this.longHaulRequestFormulateDecisionRequest.LongHaulRequestId = this.rebateRequestId;
    for(let i: number = 0; i < this.longHaulRequestOptions.length; i++){
      this.longHaulRequestFormulateDecisionRequest.LongHaulRequestOptionsFormulatedDecision[i] = new LongHaulRequestOptionFormulatedDecision();
      this.longHaulRequestFormulateDecisionRequest.LongHaulRequestOptionsFormulatedDecision[i].Id = this.longHaulRequestOptions[i].Id;
    }
    this.getRebateRequestToFormulateDecision();
  }
  getRebateRequestToFormulateDecision(): void {
    this.longHaulRequestFormulateDecisionRequest.IsFormulatedDecisionComponent = true;
    this.longHaulService.getRebateRequestToFormulateDecision(this.longHaulRequestFormulateDecisionRequest).subscribe(
      data => this.getRequestToFormulateDecisionResponseObject = data,
      () => console.log("Something went wrong!!"),
      () => this.getRebateRequestToFormulateDecisionCompleted()
    );
  }
  getRebateRequestToFormulateDecisionCompleted(): void {
    if(this.getRequestToFormulateDecisionResponseObject.Success) {
      this.longHaulRequestFormulateDecisionResponse = this.getRequestToFormulateDecisionResponseObject.Data as LongHaulRequestFormulateDecision;
      this.longHaulRequestFormulateDecisionResponse.FormulatedDecision = "This Offer is final, waiting for your reply and ETA within 72 Hours";
      this.convertRebateNumbersToLetters();
      this.checkLoadedLookups();
      //Current Date Format
      this.longHaulRequestFormulateDecisionResponse.CurrentDate = this.longHaulRequestFormulateDecisionResponse.CurrentDate != null && this.longHaulRequestFormulateDecisionResponse.CurrentDate != "" ?
      this.longHaulRequestFormulateDecisionResponse.CurrentDate.split('-')[1] + "-" +
      this.longHaulRequestFormulateDecisionResponse.CurrentDate.split('-')[0] + "-" +
      this.longHaulRequestFormulateDecisionResponse.CurrentDate.split('-')[2] : "";
    } else {
      //Enable Error
      this.submitConfirmationMode = ConfirmationMode.Error;
      this.isRequestSucceeded = true;
      //Disable Loader
      this.globalServices.isLoaderEnabled = false;
    }
  }
  getFormulatedDecision(): void {
    this.longHaulService.getFormulatedDecision(this.rebateRequestId).subscribe(
      data => this.getFormulatedDecisionResponseObject = data,
      () => console.log("Something went wrong!!"),
      () => this.getFormulatedDecisionCompleted()
    );
  }
  getFormulatedDecisionCompleted(): void {
    if(this.getFormulatedDecisionResponseObject.Success) {
      this.submittedFormulatedDecision = this.getFormulatedDecisionResponseObject.Data as string;
      this.longHaulRequestFormulateDecisionResponse.FormulatedDecision = this.submittedFormulatedDecision;
      this.checkLoadedLookups();
    } else {
      //Enable Error
      this.submitConfirmationMode = ConfirmationMode.Error;
      this.isRequestSucceeded = true;
      //Disable Loader
      this.globalServices.isLoaderEnabled = false;
    }
  }
  checkLoadedLookups(): void {
    this.noOfLoadedLookups++;
    if(this.noOfLoadedLookups == this.noOfLoadingLookups){
      //Disable Loader
      this.globalServices.isLoaderEnabled = false;
    }
  }
  convertRebateNumbersToLetters(): void {
    const numWords = require('num-words');
    let rebatePercentageLettersArr: string[] = [];
    for(let i: number = 0; i < this.longHaulRequestFormulateDecisionResponse.LongHaulRequestOptionsFormulatedDecision.length; i++){
      if(+this.longHaulRequestFormulateDecisionResponse.LongHaulRequestOptionsFormulatedDecision[i].RebatePercentage == 0){
        this.longHaulRequestFormulateDecisionResponse.LongHaulRequestOptionsFormulatedDecision[i].RebatePercentageLetters = "Zero";
      } else if(this.longHaulRequestFormulateDecisionResponse.LongHaulRequestOptionsFormulatedDecision[i].RebatePercentage == "-" || this.longHaulRequestFormulateDecisionResponse.LongHaulRequestOptionsFormulatedDecision[i].RebatePercentage == "--"){
        this.longHaulRequestFormulateDecisionResponse.LongHaulRequestOptionsFormulatedDecision[i].RebatePercentageLetters = "No Rebate";
      } else {
        rebatePercentageLettersArr = numWords(this.longHaulRequestFormulateDecisionResponse.LongHaulRequestOptionsFormulatedDecision[i].RebatePercentage).split(' ');
        this.longHaulRequestFormulateDecisionResponse.LongHaulRequestOptionsFormulatedDecision[i].RebatePercentageLetters = "";
        for(let j: number = 0; j < rebatePercentageLettersArr.length; j++){
          rebatePercentageLettersArr[j] = rebatePercentageLettersArr[j].charAt(0).toUpperCase() + rebatePercentageLettersArr[j].slice(1);
          this.longHaulRequestFormulateDecisionResponse.LongHaulRequestOptionsFormulatedDecision[i].RebatePercentageLetters += rebatePercentageLettersArr[j];
          if(j != rebatePercentageLettersArr.length - 1)
            this.longHaulRequestFormulateDecisionResponse.LongHaulRequestOptionsFormulatedDecision[i].RebatePercentageLetters += " ";
        }
      }
    }
  }
  submit(): void {
    //Enable Loader
    this.globalServices.isLoaderEnabled = true;
    this.longHaulRequestFormulateDecisionResponse.AdminEmail = this.currentUser.UserName != "" ? this.currentUser.UserName : this.currentUser.Email;
    //this.longHaulRequestFormulateDecisionResponse.AdminEmail = "Nada.Alaskari@linkdev.com";
    this.formulateDecision();
  }
  formulateDecision(): void {
    this.longHaulService.formulateDecision(this.longHaulRequestFormulateDecisionResponse).subscribe(
      data => this.formulateDecisionResponseObject = data,
      () => console.log("Something went wrong!!"),
      () => this.formulateDecisionCompleted()
    );
  }
  formulateDecisionCompleted(): void {
    if(!this.formulateDecisionResponseObject.Success) {
      //Enable Error / Warning
      if(this.formulateDecisionResponseObject.ErrorMessages[0] == ErrorsEnum.InternalServerError.toString())
        this.submitConfirmationMode = ConfirmationMode.Error;
      else if(this.formulateDecisionResponseObject.ErrorMessages[0] == ErrorsEnum.TaskCompletedByAnotherUser.toString())
        this.submitConfirmationMode = ConfirmationMode.Warning;
    }
    //Enable Confirmation
    this.isRequestSucceeded = true;
    //Disable Loader
    this.globalServices.isLoaderEnabled = false;
  }
  later(): void {
    this.router.navigateByUrl('/myTasks');
  }
  RestudyFunc():void{
    this.longHaulService.restudy(this.rebateRequestId,this.longHaulRequestFormulateDecisionResponse.AdminEmail).subscribe(
      data => this.RestudyResponseObject = data,
      () => console.log("Something went wrong!!"),
      () => this.RestudyCompleted()
    );
  }
  RestudyCompleted(): void {
    if(!this.RestudyResponseObject.Success) {
      //Enable Error / Warning
      if(this.RestudyResponseObject.ErrorMessages[0] == ErrorsEnum.InternalServerError.toString())
        this.submitConfirmationMode = ConfirmationMode.Error;
      else if(this.RestudyResponseObject.ErrorMessages[0] == ErrorsEnum.TaskCompletedByAnotherUser.toString())
        this.submitConfirmationMode = ConfirmationMode.Warning;
    }
    //Enable Confirmation

    this.isRestudySucceeded = true;
    //Disable Loader
    this.globalServices.isLoaderEnabled = false;
  }
  Restudy(): void {
    //Enable Loader
    this.globalServices.isLoaderEnabled = true;
    this.longHaulRequestFormulateDecisionResponse.AdminEmail = this.currentUser.UserName != "" ? this.currentUser.UserName : this.currentUser.Email;
    this.RestudyFunc();
    //this.router.navigateByUrl('/myTasks');
  }
}

enum ConfirmationMode {
  Success  = 1,
  Warning = 2,
  Error = 3
}
